import { useScrollReveal } from '@/hooks/useScrollReveal';

const LINKEDIN_URL = 'https://www.linkedin.com/in/vinoth-trevor-skanthavarathan-01b6ba141/';

const FinalCTA = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section
      ref={ref}
      data-testid="final-cta-section"
      className={`section-reveal ${isVisible ? 'visible' : ''}`}
      style={{ backgroundColor: '#353840' }}
    >
      <div className="content-narrow text-center">
        <p className="body-text-secondary" data-testid="final-cta-line1">
          The misalignment you&rsquo;re not seeing today is compounding.
        </p>
        <p className="body-text-secondary mt-2" data-testid="final-cta-line2">
          Every week that gap goes unnamed costs you runway and decisions you cannot walk back.
        </p>

        <div className="mt-10">
          <a
            href={LINKEDIN_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-button"
            className="cta-button"
            style={{ display: 'inline-block' }}
          >
            Connect on LinkedIn &rarr;
          </a>
        </div>

        <p className="text-muted mt-5" data-testid="final-cta-reassurance">
          No pitch. No funnel. Just a direct conversation about what&rsquo;s actually broken.
        </p>
      </div>
    </section>
  );
};

export default FinalCTA;
